<div class="entry-process-form">
  <form [formGroup]="entryProcessFormGroup">
    <div class="entry-process-form-body">
      <span class="flex-1">
        <div class="w-h-label manager-comment-label">
          {{ "entry.model.status" | translate }}
        </div>
        <div class="entry-status-container">
          <div>
            <mat-form-field whFlex="50">
              <mat-label>{{ "entry.model.status" | translate }}</mat-label>
              <mat-select
                formControlName="entryStatusId"
                required
                [disabled]="
                  entryProcessFormGroup.controls['entryStatusId'].disabled
                "
                (selectionChange)="updateEntryStatus()"
              >
                <mat-option
                  *ngFor="
                    let entryStatusId of entryStatusIdEnumArray;
                    let i = index
                  "
                  [value]="entryStatusId"
                  [disabled]="i === 0 && isResetDisabled"
                >
                  {{ "entry.enum.status." + entryStatusId | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            style="display: flex; flex-direction: column"
            *ngIf="isRevertToDraftEnabled"
          >
            <mat-form-field required *ngIf="entryStatusId === 0" whFlex>
              <mat-label>{{
                "entry.model.revertToDraft.quickMessage" | translate
              }}</mat-label>
              <textarea
                formControlName="feedback"
                rows="2"
                placeholder="{{
                  'entry.model.revertToDraft.quickMessage' | translate
                }}"
                matInput
              >
              </textarea>
              <mat-hint align="start">{{
                "entry.model.revertToDraft.warning" | translate
              }}</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </span>
      <span class="flex-1">
        <div class="w-h-label manager-comment-label">
          {{ "entry.model.managercomment" | translate }}
        </div>
        <div>
          <mat-form-field whFlex>
            <textarea
              formControlName="managerComment"
              [disabled]="true"
              rows="5"
              matInput
            >
            </textarea>
          </mat-form-field>
        </div>
      </span>
    </div>
    <w-h-button-group align="end" class="m--16">
      <w-h-button
        [text]="'app.cancel.label' | translate | uppercase"
        matIcon="close"
        type="stroked"
        [disabled]="saving"
        (clicked)="cancelChanges()"
      />
      <w-h-button
        [text]="'app.save.label' | translate | uppercase"
        matIcon="save"
        [isLoading]="saving"
        color="accent"
        type="flat"
        [disabled]="entryProcessFormGroup.invalid"
        (clicked)="handleSubmit()"
      />
    </w-h-button-group>
  </form>
</div>
